// @TODO Update this to relative path before merging
export const GET_MASONRY_NODE_ENDPOINT = '/v1/masonry-node/';

export const MASONRY_NODE_DISMISS_ENDPOINT = 'v1/masonry-node/dismiss';
